import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {
	QUERY_KEY_PASSENGER_CHART_ROUTE,
	QUERY_KEY_PASSENGER_CHART_ROUTES
} from '@containers/monitoringPlatform/passengerCharts/queryHooks/constants/queryKey'
import {
	getPassengerChartRouteApi,
	getPassengerChartRoutesApi
} from '@containers/monitoringPlatform/passengerCharts/api/api'

const STALE_TIME = 1000 * 60 * 5

export const useGetPassengerChartRoutesQuery = (
	accountId: number,
	date: string
) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getPassengerChartRoutesApi(accountId, date, onShowError),
		queryKey: [QUERY_KEY_PASSENGER_CHART_ROUTES, accountId?.toString(), date],
		staleTime: STALE_TIME,
		enabled: !!accountId && !!date,
		placeholderData: keepPreviousData,
	})
}

export const useGetPassengerChartRouteQuery = (
	accountId: number,
	routeId: number | null,
	date: string
) => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getPassengerChartRouteApi(accountId, routeId as number, date, onShowError),
		queryKey: [QUERY_KEY_PASSENGER_CHART_ROUTE, accountId?.toString(), routeId?.toString(), date],
		staleTime: STALE_TIME,
		enabled: !!accountId && !!routeId && !!date,
	})
}
